<template>
  <TwoColumnsContainer :has-padding="true" class="template-loader__container">
    <div slot="main" class="template-loader__container__main">
      <SkeletonLoader
        :show-animation="true"
        class="template-loader__container__main-title"
      >
        <div />
        <div />
        <div />
      </SkeletonLoader>
      <SkeletonLoader
        :show-animation="true"
        class="template-loader__container__main-chart"
      >
        <div />
      </SkeletonLoader>
      <SkeletonLoader
        :show-animation="true"
        class="template-loader__container__main-button"
      >
        <div />
      </SkeletonLoader>
    </div>
    <div slot="content">
      <SkeletonLoader
        :show-animation="true"
        class="template-loader__container-news"
      >
        <div />
      </SkeletonLoader>
      <SkeletonLoader
        :show-animation="true"
        class="template-loader__container-row"
      >
        <div />
        <div />
        <div />
        <div />
      </SkeletonLoader>
      <SkeletonLoader
        :show-animation="true"
        class="template-loader__container-row"
      >
        <div />
        <div />
        <div />
        <div />
      </SkeletonLoader>
    </div>
  </TwoColumnsContainer>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import { SkeletonLoader } from '@warrenbrasil/nebraska-web';
import TwoColumnsContainer from './TwoColumnsContainer.vue';

@Component({
  components: {
    SkeletonLoader,
    TwoColumnsContainer
  }
})
export default class TwoColumnsContainerLoader extends Vue {}
</script>

<style lang="less" scoped>
.template-loader__container,
.template-loader__container__main {
  height: 100%;
}

.template-loader__container__main {
  display: flex;
  align-content: space-between;
  justify-content: space-between;
  flex-direction: column;
}

.template-loader__container__main-title {
  div {
    width: 20%;
    height: 35px;
    border-radius: 10px;
    &:first-of-type {
      width: 40%;
      margin: @size-spacing-x600 0;
    }
    &:last-of-type {
      margin-top: @size-spacing-x350;
      height: 20px;
    }
  }
}

.template-loader__container__main-chart {
  div {
    width: 100%;
    height: 300px;
    border-radius: 10px;
    margin: @size-spacing-x400 0;
  }
}

.template-loader__container__main-button {
  div {
    margin-top: @size-spacing-x500;
    width: 20%;
    height: 35px;
    border-radius: 10px;
  }
}

.template-loader__container-news,
.template-loader__container-row {
  width: 100%;
  padding: @size-spacing-x600 0;
}

.template-loader__container-news {
  div {
    border-radius: 10px;
    height: 200px;
    width: 100%;
  }
}

.template-loader__container-row {
  div {
    height: 50px;
    width: 80%;
    border-radius: 10px;
    margin: @size-spacing-x300 0;
    &:first-of-type {
      width: 50%;
      height: 32px;
      margin-top: 0;
    }
  }
}
</style>
